import React from 'react';
import PropTypes from 'prop-types';
import { componentOnly } from '@beef/react';
import { enhancedConnect } from "../../utils";
import { GridItem } from "./GridItem";
import { GridContainer } from "./GridContainer";
var _AutoGrid = function _AutoGrid(_ref) {
  var children = _ref.children,
    gap = _ref.gap,
    noScroll = _ref.noScroll,
    noSkew = _ref.noSkew,
    className = _ref.className,
    growItems = _ref.growItems;
  /**
   * В случае, если карточек 4, отображение становится смещенным
   */
  return /*#__PURE__*/React.createElement(GridContainer, {
    className: className,
    gap: gap,
    isSkewed: !noSkew,
    maxColumns: React.Children.count(children) === 4 ? 2 : 3,
    noScroll: noScroll,
    "data-t-id": "components-AutoGrid"
  }, React.Children.map(children, componentOnly(function (child) {
    return /*#__PURE__*/React.createElement(GridItem, {
      grow: growItems,
      key: child.key
    }, child);
  })));
};
export var AutoGrid = enhancedConnect({
  children: PropTypes.node,
  noSkew: PropTypes.bool,
  growItems: PropTypes.bool,
  noScroll: PropTypes.bool,
  gap: PropTypes.oneOf(['small', 'medium', 'large'])
})(_AutoGrid);